/**
 * FRONSYSTEM 4.1: единый текст ошибки API для Redux rejectWithValue, сервисов и catch.
 */
import { pickSafeRussianBackendMessage, pickHttpStatusRussianFallback } from './safeRussianBackendMessage';

/**
 * @param {unknown} error — обычно AxiosError
 * @param {string} [fallbackOverride] — русский fallback, если тело ответа пустое / не для UI (иначе — по HTTP-статусу)
 * @returns {{ message: string, status?: number }}
 */
export function apiRejectPayload(error, fallbackOverride) {
  const status = error?.response?.status ?? error?.status;
  const fromBody = error?.response?.data?.error ?? error?.response?.data?.message;
  const raw =
    fromBody != null && fromBody !== ''
      ? fromBody
      : (typeof error?.message === 'string' ? error.message : undefined);
  const fb =
    typeof fallbackOverride === 'string' && fallbackOverride.length > 0
      ? fallbackOverride
      : pickHttpStatusRussianFallback(status);
  return {
    message: pickSafeRussianBackendMessage(raw, fb),
    status,
  };
}
